"use client";

import { useState } from "react";
import { InputProps } from "@/src/types/input.type";
import DateInput from "./DateInput";
import DropdownInput from "./DropdownInput";

export function InputExt({ type, className, value, options, onChanged, onBlur, readOnly }: InputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = type?.toLowerCase() === "password" ? "password" : undefined;
  const isPassword = inputType === "password";
  const resolvedType = isPassword ? (showPassword ? "text" : "password") : undefined;
  const input = (
    <input
      autoFocus
      type={resolvedType}
      className={className}
      value={(type === "boolean" && value !== undefined) ?
        (String(value).toLowerCase() === "true" ? "true" : "false"):
        value ?? ""}
      onChange={(event) => {
        if (!readOnly) onChanged?.(event.currentTarget.value);
      }}
      onBlur={onBlur}
      readOnly={readOnly}
      tabIndex={readOnly ? -1 : 0}
      onFocus={(event) => {
        if (readOnly) event.currentTarget.blur();
      }}
    />
  );

  return (type === "date" && !readOnly) ? (
    <DateInput
      className={className}
      value={value}
      onChanged={onChanged}
      onBlur={onBlur}
    />
  ) : (type === "boolean" && !readOnly) ? (
    <DropdownInput
      className={className}
      value={String(value).toLowerCase() === "true" ? "true" : "false"}
      options={[["true", true], ["false", false]]}
      onChanged={onChanged}
      onBlur={onBlur}
    />
  ) : (options && !readOnly) ? (
    <DropdownInput
      className={className}
      value={value}
      options={options}
      onChanged={onChanged}
      onBlur={onBlur}
    />
  ) : isPassword ? (
    <div className="input-group input-group-sm">
      {input}
      <button
        type="button"
        className="btn btn-outline-secondary"
        aria-label={showPassword ? "Hide password" : "Show password"}
        title={showPassword ? "Hide password" : "Show password"}
        onPointerDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        onClick={(event) => {
          event.stopPropagation();
          setShowPassword((current) => !current);
        }}
      >
        <i className={`bi bi-eye${showPassword ? "-slash" : ""}`} aria-hidden="true" />
      </button>
    </div>
  ) : (
    input
  );
};

export default function Input({
  className,
  labelClassName,
  label,
  value,
  type,
  options,
  onChanged,
  readOnly = false
}: InputProps) {
  const inputType = label?.toLowerCase().includes("password") ? "password" : type;

  return (
    <div className="mb-3">
      <label className={`form-label fw-bolder ${labelClassName ?? ""}`}>{label}</label>
      <InputExt type={inputType} className={className} value={value} options={options} onChanged={onChanged} readOnly={readOnly} />
    </div>
  );
}
